module.exports = __webpack_public_path__ + "static/img/SD.a3796441.svg";